module.exports = __webpack_public_path__ + "static/img/img1.69c706d6.png";